/** First screen: start a table, or walk into one with a code. */

import { el } from './dom.js';
import { logoElement } from './logo.js';

export interface HomeActions {
  create(name: string): void;
  join(code: string, name: string): void;
}

export function mountHome(actions: HomeActions, initialName: string): HTMLElement {
  const root = el('div', 'lobby lobby--home');

  const nameField = el('input', 'field field--name') as HTMLInputElement;
  nameField.placeholder = 'Je naam';
  nameField.maxLength = 16;
  nameField.value = initialName;
  nameField.setAttribute('autocomplete', 'nickname');

  const codeField = el('input', 'field field--code') as HTMLInputElement;
  codeField.placeholder = 'CODE';
  codeField.maxLength = 5;
  codeField.autocapitalize = 'characters';
  codeField.spellcheck = false;
  codeField.addEventListener('input', () => {
    codeField.value = codeField.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    joinButton.disabled = codeField.value.length < 4;
  });

  const createButton = el('button', 'btn btn--primary btn--start', 'Nieuwe tafel');
  createButton.addEventListener('click', () => actions.create(nameField.value.trim()));

  const joinButton = el('button', 'btn', 'Meedoen');
  joinButton.disabled = true;
  joinButton.addEventListener('click', () =>
    actions.join(codeField.value.trim(), nameField.value.trim()),
  );

  const joinRow = el('div', 'link-row');
  joinRow.append(codeField, joinButton);

  root.append(
    logoElement(),
    el('p', 'lobby__hint', 'Manillen wanneer je wil. Bots vullen de lege stoelen.'),
    nameField,
    createButton,
    el('div', 'home__or', 'of doe mee aan een tafel'),
    joinRow,
  );

  return root;
}
